import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';

/**
 * 
 * @param {object} props
 * @param {array} props.activeTab
 * @param {array} props.menu 
 * @param {object} props.menu[i]
 * @param {string} props.menu[i].key
 * @param {string} props.menu[i].label
 * @param {React component} props.menu[i].icon
 * @param {function} props.updateActiveTab
 */

const VerticalNavigationCardGroup = (props) => {
  return (
    <div>
    {
      props.menu.map((item)=>{
        if(item.key === props.activeTab){
          return (
            <div key={item.key}
              data-value={item.key}
              css={css`
                border: 1px solid rgba(143,206,238,0.1);
                border-right: 4px solid #0099e5;
                border-radius: 2px;
                padding: 20px 0;
                
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
                justify-content: space-between;
              `}
            >
              <div css={css`
                color: #0099e5;
                font-size: 1.8rem;
                text-align: center;
                pointer-events: none;
              `}>{item.icon}</div>
              <div css={css`
                color: #0099e5;
                font-size: 0.9rem;
                font-weight: 600;
                text-align: center;
                pointer-events: none;
              `}>{item.label}</div>
            </div>
          )
        }else{
          return (
            <div key={item.key}
              data-value={item.key}
              onClick={(e)=>props.updateActiveTab(e.target.dataset.value)}
              css={css`
                border-radius: 2px;
                padding: 20px 0;
                display: flex;
                flex-direction: column;
                flex-wrap: nowrap;
                justify-content: space-between;
                cursor: pointer;
                box-shadow: 0 1px 4px rgba(0,0,0,0.2);
                &:hover{
                  transition: all 0.6s ease;
                  box-shadow: 0 2px 8px rgba(0,0,0,0.6);
                  svg {
                    color: #0099e5;
                    transition: all 0.6s ease;
                  }
                  div: last-child {
                    color: #0099e5;
                    transition: all 0.6s ease;
                  }
                }
              `}
            >
              <div css={css`
                color: #9E9E9E;
                font-size: 1.8rem;
                text-align: center;
                pointer-events: none;
              `}>{item.icon}</div>
              <div css={css`
                color: #9E9E9E;
                font-size: 0.9rem;
                font-weight: 600;
                text-align: center;
                pointer-events: none;
              `}>{item.label}</div>
            </div>
          )
        }
      })
    } 
    </div>
  )
}

export default VerticalNavigationCardGroup;